<app-modal
  #previousChatsModal
  (isDismissing)="resetChatHistoryState()"
  (isClosing)="resetChatHistoryState()"
  [modalConfig]="{
    titleText: 'Previous Chats',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    options: { size: 'lg' }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container px-3">
    <input
      #searchChatHistory
      type="search"
      class="form-control mt-2 mb-4"
      placeholder="Search chats..."
      aria-label="Search"
      [style.lineHeight]="'1.4'"
      [value]="chatHistorySearchTerm"
      (input)="chatHistorySearchTermChanged($event)" />
    <ng-container *ngIf="!chatHistoryIsLoading; else loadingTemplate">
      <ng-template #emptyStateTemplate>
        <div
          class="d-flex justify-content-center align-items-center w-100"
          style="min-height: 220px">
          <p class="mb-0">No previous chats found.</p>
        </div>
      </ng-template>
      <ng-container *ngIf="previousChats.length; else emptyStateTemplate">
        <ng-container *ngFor="let chat of previousChats">
          <div
            class="d-flex w-100 previous-chat-row p-3"
            (click)="openConversation(chat)">
            <i class="bi bi-chat me-3 fs-18"></i>
            <div class="w-100">
              <div class="d-flex justify-content-between align-items-start">
                <app-safehtml
                  [html]="chat.title"
                  [removeMargin]="true"
                  [classList]="['mb-1', 'me-2']"></app-safehtml>
                <p class="text-muted fs-14 mb-1 ms-2 text-nowrap">
                  {{ getChatHistoryDisplayDate(chat.updated_at) }}
                </p>
              </div>
              <ng-container *ngIf="chat.search_preview">
                <app-safehtml
                  [html]="chat.search_preview"
                  [removeMargin]="true"
                  [classList]="['text-muted', 'fs-12', 'mb-1']"></app-safehtml>
              </ng-container>
              <hr class="border border-primary border-1 mb-0" />
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="chatHistoryMeta && chatHistoryMeta.pageCount > 1">
          <div class="d-flex justify-content-center mt-2">
            <ngb-pagination
              [(page)]="chatHistoryFilters.page"
              [pageSize]="chatHistoryFilters.per_page"
              [collectionSize]="chatHistoryMeta.totalCount"
              (pageChange)="loadConversationHistory()"
              [maxSize]="5"
              [ellipses]="true"></ngb-pagination>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #loadingTemplate>
      <div class="w-100" style="min-height: 220px">
        <app-loader></app-loader>
      </div>
    </ng-template>
  </div>
</app-modal>
